export default __webpack_public_path__ + "static/media/hotel_img_jp_05.e5be3605.jpg";